import { useRef } from 'react';

import { initMixpanel } from '@core/analytics';

import AppProvider from './contexts/app';
import AppRoutes from './routes';

const App = () => {
  const isMixPanelInitiated = useRef<boolean>(false);
  if (!isMixPanelInitiated.current) {
    initMixpanel();
    isMixPanelInitiated.current = true;
  }

  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
};

export default App;
